import {useContext, useRef} from 'react';
import {Utils} from '../Utils';
import {AppContext} from '../App';
import {BackButton} from './BackButton';
import {PostUtil} from './PostUtil';
import './ContactPage.css';

export function ContactPage()
{
	const closure = useContext(AppContext);
	const contactText = Utils.tr('COURSE_CONTACT_US_2');
	const contactText2 = Utils.tr('CONTACT_US_2');
	const contactText3 = Utils.tr('CONTACT_US_3');
	// const q1 = Utils.tr('CONTACT_Q1');
	const q2 = Utils.tr('CONTACT_Q2');
	const q3 = Utils.tr('CONTACT_Q3');
	const q4 = Utils.tr('CONTACT_Q4');
	const submitBtnText = Utils.tr('CONTACT_SUBMIT');

	const f1 = Utils.tr('CONTACT_ADDR');
	const f2 = Utils.tr('CONTACT_PHONE');
	const f3 = Utils.tr('CONTACT_EMAIL');
	const f4 = Utils.tr('CONTACT_WEB');

	const v1 = Utils.tr('CONTACT_ADDR_VAL');
	const v2 = Utils.tr('CONTACT_PHONE_VAL');
	const v3 = Utils.tr('CONTACT_EMAIL_VAL');
	const v4 = Utils.tr('CONTACT_WEB_VAL');

	// const q11 = Utils.tr('CONTACT_Q1_OPT_1');
	// const q12 = Utils.tr('CONTACT_Q1_OPT_2');
	// const q13 = Utils.tr('CONTACT_Q1_OPT_3');

	const q5 = Utils.tr('CONTACT_Q5');
	const q51 = Utils.tr('CONTACT_Q5_OPT_1');
	const q52 = Utils.tr('CONTACT_Q5_OPT_2');

	const formRef = useRef(null);
	const submitBtnRef = useRef(null);

	const onBackBtnClick = () =>
	{
		//closure.dispatch({type: 'pop'});
        window.history.back();
	};

	const onCaptchaShow = (blob, postData) =>
	{
		const objectURL = URL.createObjectURL(blob);
		let img = new Image();
		img.src = objectURL;
		const onload = () => 
		{
			img.removeEventListener('load', onload);
			const h = img.height;
			const w = img.width;
			const pw = 50;
			const ph = 50;
			const margin = 10;
			let s1 = {
				background: 'url("' + objectURL + '") 0 0 no-repeat',
				width: (w - pw - margin) + 'px',
				height: h + 'px',
			};

			let s2 = {
				background: 'url("' + objectURL + '") right 0 no-repeat',
				width: pw + 'px',
				height: ph + 'px',
				left: 'calc(50% - ' + (pw /2) + 'px',
				top: 'calc(50% - ' + (ph /2) + 'px',
			};

			let pointer = null;
			let po = [];
			let code = [];

			const onMouseUp = (evt) =>
			{
				evt.preventDefault();
				evt.stopPropagation();
				if(evt.type === 'mouseup')
				{
					window.removeEventListener('mouseup', onMouseUp);
					pointer.parentNode.removeEventListener('mousemove', onMouseMove);
					pointer.parentNode.removeEventListener('mouseup', onMouseUp);
					pointer.addEventListener('mousedown', onMouseDown);
				}
				else
				{
					window.removeEventListener('touchend', onMouseUp);
					pointer.parentNode.removeEventListener('touchmove', onMouseMove);
					pointer.parentNode.removeEventListener('touchend', onMouseUp);
					pointer.addEventListener('touchstart', onMouseDown);
				}
			}

			const onMouseMove = (evt) =>
			{
				evt.preventDefault();
				evt.stopPropagation();
				let dx, dy;
				if(evt.type === 'mousemove')
				{
					dx = evt.pageX - po[0];
					dy = evt.pageY - po[1];
				}
				else
				{
					let t = evt.touches;
					if(!t.length) return;
					dx = t[0].pageX - po[0];
					dy = t[0].pageY - po[1];
				}

				let cx = po[2] + dx;
				let cy = po[3] + dy;
				let pn = pointer.parentNode;
				let pnw = pn.clientWidth;
				let pnh = pn.clientHeight;
				let pow = pointer.clientWidth;
				let poh = pointer.clientHeight;

				if(cx < 0) cx = 0;
				if(cx + pow > pnw) cx = pnw - pow;
				if(cy < 0) cy = 0;
				if(cy + poh > pnh) cy = pnh - poh;
				pointer.style.left = cx + 'px';
				pointer.style.top = cy + 'px';
				code = [cx, cy];
			};

			const onMouseDown = (evt) =>
			{
				evt.preventDefault();
				evt.stopPropagation();
				if(evt.type === 'mousedown')
				{
					po = [evt.pageX, evt.pageY, pointer.offsetLeft, pointer.offsetTop];
					pointer.parentNode.addEventListener('mousemove', onMouseMove);
					pointer.parentNode.addEventListener('mouseup', onMouseUp);
					pointer.removeEventListener('mousedown', onMouseDown);
					window.addEventListener('mouseup', onMouseUp);	
				}
				else
				{
					let t = evt.touches;
					if(!t.length) return;
					po = [t[0].pageX, t[0].pageY, pointer.offsetLeft, pointer.offsetTop];
					pointer.parentNode.addEventListener('touchmove', onMouseMove);
					pointer.parentNode.addEventListener('touchend', onMouseUp);
					pointer.removeEventListener('touchstart', onMouseDown);
					window.addEventListener('touchend', onMouseUp);
				}
			};

			const begin = () =>
			{
				if(pointer)
				{
					if(window.hasOwnProperty('ontouchstart'))
					{
						pointer.addEventListener('touchstart', onMouseDown);
					}
					
					if(window.hasOwnProperty('onmousedown'))
					{
						pointer.addEventListener('mousedown', onMouseDown);
					}
				}
			};

			const onMount = (elm) =>
			{
				if(elm)
				{
					pointer = elm.getElementsByClassName('ca-pointer')[0];
					begin();
				}
			};

			const cleanup = () =>
			{
				if(pointer)
				{
					if(window.hasOwnProperty('ontouchstart'))
					{
						onMouseUp(new Event('touchend'));
						pointer.removeEventListener('touchstart', onMouseDown);
					}
					if(window.hasOwnProperty('onmousedown'))
					{
						onMouseUp(new Event('mouseup'));
						pointer.removeEventListener('mousedown', onMouseDown);
					}				
				}
			};

			const onRefresh = (evt) =>
			{
				const btn = evt.currentTarget;
				btn.classList.add('is-loading');
				PostUtil.makeRequest('/v1/captcha').then((resp) =>
				{
					if(PostUtil.handleResponse(resp, closure.pushNotification))
					{
						// cleanup();
						resp.blob().then((blob) =>
						{
							if(blob && pointer)
							{
								// onCaptchaShow(blob, postData);
								const newUrl = URL.createObjectURL(blob);
								pointer.style.background = 'url("' + newUrl + '") right 0 no-repeat';
								pointer.parentNode.style.background = 'url("' + newUrl + '") 0 0 no-repeat';

							}
						});	
					}
					return resp;
				})
				.finally(() =>
				{
					btn.classList.remove('is-loading');
				});
			}

			const onDone = (evt) =>
			{	
				if(code.length !== 0)
				{
					cleanup();
					postData['checkCode'] = code.join(',');

					let btn = evt.currentTarget;
					if(btn)
					{
						btn.classList.add('is-loading');
					}

					post(postData).then((resp) =>
					{
						if(resp.status !== 406)
						{
							closure.setModalContent(null);
						}
						else
						{
							if(resp.headers.get('Content-Type') !== 'image/png')
							{
								begin();
								closure.pushNotification({elm: (
									<div>
										<p><span>{Utils.tr('CAPTCHA_ERR')}</span></p>
									</div>)
								, clazz: 'is-danger'
								});
							}
						}
						return resp;
					})
					.finally(() =>
					{
						btn.classList.remove('is-loading');
					});
				}
				else
				{
					//not accept
					closure.pushNotification({elm: (
						<div>
							<p><span>{Utils.tr('CAPTCHA_ERR')}</span></p>
						</div>)
					, clazz: 'is-danger'
					});
				}
			};

			const cap1 = Utils.tr('CAPTCHA_HINT');
			const cap2 = Utils.tr('CAPTCHA_DONE');
			const cap3 = Utils.tr('CAPTCHA_NEXT');

			let content = (
				<div className="box ca-modal" ref={(r) => {onMount(r)}}>
					<div className="block ca">
						<div className="ca-bg" style={s1}>
							<div className="ca-pointer is-shown" style={s2}></div>
						</div>
					</div>
					<div className="block quide has-text-centered">
						<p>{cap1}</p>
					</div>
					<div className="block buttons">
						<button className="button is-primary style-btn2" onClick={onDone}>
							<i className="fa fa-circle-check pr-2"></i>
							<span>{cap2}</span>
						</button>
						<button className="button is-warning style-btn2" onClick={onRefresh}>
							<i className="fa fa-rotate-right pr-2"></i>
							<span>{cap3}</span>
						</button>
					</div>
				</div>);

			closure.setModalContent({content, onClose: cleanup});
		};
		img.addEventListener('load', onload);
	}

	const post = (data) =>
	{
		let data2 = Object.assign({}, data, closure.userInfo, {language: closure.lang});
		return PostUtil.makeRequest('/v1/post', data2).then((resp) =>
		{
			if(resp.status === 406)
			{
				if(resp.headers.get('Content-Type') === 'image/png')
				{
					resp.blob().then((blob) =>
					{
						if(blob)
						{
							onCaptchaShow(blob, data);
						}
					});
				}
				else
				{
					// image not refresh;
				}	
			}
			else if(PostUtil.handleResponse(resp, closure.pushNotification))
			{
				closure.dispatch({type: 'push', page: 'thank'});
			}
			return resp;
		})
	};

	const onSubmitClick = () =>
	{
		let e = 0;
		let data = {};
		if(process.env.REACT_APP_SKIP_INPUT === undefined)
		{
			const form = formRef.current;
			let v, f;
			let fields = ['favorite_career', 'question', 'exchange_country', 'stu_parent'];
			let len = fields.length;
			let elm;
			
			while(len--)
			{
				f = fields[len];
				v = form[f].value.trim();
				elm = form[f].nodeName === 'SELECT' ? form[f].parentNode : form[f];
				if(!v)
				{
					elm.classList.add('is-danger');
					e = 1;
				}
				else
				{
					elm.classList.remove('is-danger');
					data[f] = v;
				}
			}
		}

		if(!e)
		{
			if(process.env.REACT_APP_SKIP_POST !== undefined)
			{
				closure.dispatch({type: 'push', page: 'thank'});
				return;
			}
			const btn = submitBtnRef.current;
			if(btn)
			{
				btn.classList.add('is-loading');
			}
			post(data).finally(() =>
			{
				btn.classList.remove('is-loading');
			});
		}
	};

	return (
		<>
			<section className="box style-box">
		  		<div className="columns is-desktop">
					<div className="column left is-6-desktop">
						<h1 className="title is-5">{contactText}</h1>
						<h3 className="subtitle has-text-weight-semibold is-3">{contactText2}</h3>
						<p>{contactText3}</p>


						<div className="dbox mt-6">
							<div className="icon">
								<span className="fa fa-map-marker"></span>
							</div>
							<div className="text">
								<p><span>{f1}:</span> {v1}</p>
							</div>
						</div>

						<div className="dbox">
							<div className="icon">
								<span className="fa fa-phone"></span>
							</div>
							<div className="text">
								<p><span>{f2}:</span> <a href={"tel://" + v2}>{v2}</a></p>
							</div>
						</div>

						<div className="dbox">
							<div className="icon">
								<span className="fa fa-paper-plane"></span>
							</div>
							<div className="text">
								<p><span>{f3}:</span> <a href={"mailto:" + v3}>{v3}</a></p>
							</div>
						</div>

						<div className="dbox">
							<div className="icon">
								<span className="fa fa-globe"></span>
							</div>
							<div className="text">
								<p><span>{f4}:</span> <a target="_blank" href={"https://" + v4}>{v4}</a></p>
							</div>
						</div>
					</div>

					<div className="column right has-text-centered is-5-desktop is-offset-1-desktop">
						<form ref={formRef}>
							<div className="field">
								<label className="label">{q5}</label>
								<div className="control">
									<div className="select is-rounded">
										<select name="stu_parent">
											<option value=""></option>
											<option value="yes">{q51}</option>
											<option value="no">{q52}</option>
										</select>
									</div>
								</div>
							</div>

							<div className="field">
								<label className="label">{q2}</label>
								<div className="control">
									<input className="input" type="text" name="favorite_career" />
								</div>
							</div>

							<div className="field">
								<label className="label">{q4}</label>
								<div className="control">
									<input className="input" type="text" name="exchange_country" />
								</div>
							</div>

							<div className="field">
								<label className="label">{q3}</label>
								<div className="control">
									<textarea className="textarea" name="question"></textarea>
								</div>
							</div>

							<div className="has-text-centered">
								<button className="button is-primary is-medium style-btn2" onClick={onSubmitClick} type="button" ref={submitBtnRef}>
									<i className="fa fa-paper-plane pr-2"></i>
									<span>{submitBtnText}</span>
								</button>
							</div>
						</form>
					</div>
				</div>
			</section>

			<div className="navigation">
				<div className="block has-text-centered">
					<BackButton onClick={onBackBtnClick} />
				</div>
			</div>
		</>
	);
}
